(ns lupapalvelu.ui2.sortable-table
  (:require ["@dnd-kit/react" :refer [DragDropProvider]]
            ["@dnd-kit/react/sortable" :refer [useSortable]]
            ["react" :as react]
            [cljs-bean.core :refer [->clj]]
            [lupapalvelu.ui.common :refer [loc]]
            [lupapalvelu.ui2.button :refer [button]]
            [lupapalvelu.ui2.dialog :as dialog]
            [lupapalvelu.ui2.icons :as icons]
            [lupapalvelu.ui2.spinner :refer [spinner]]
            [lupapalvelu.ui2.toggle-group :refer [toggle-group]]
            [malli.core :as m]
            [reagent.core :as r :refer [defc]]
            [reagent.hooks :as hooks]
            [reagent.ratom :as ratom]))

(def initial-state
  {:config-modal-open false
   :start             0
   :limit             20
   ;; TODO:
   :sort              []
   :loading           false
   :expand-default    false
   :columns           nil
   :order             nil})

(def TableState
  [:map {:closed true}
   [:config-modal-open :bool]
   [:start :int]
   [:limit :int]
   ;; TODO:
   [:sort [:map {:closed true}]]
   [:loading :bool]
   [:expand-default :bool]
   [:columns :any]
   [:order :any]])

(def table-context (react/createContext {}))
(def TableContextProvider (.-Provider table-context))

(def ColumnKey [:or :string :keyword])

(defn- create-cell-style [{{:keys [flex min-width max-width width word-break]
                            :or   {flex      1
                                   min-width "0px"}}                          :cell-style}]
  (cond->
    {:flex      flex
     :min-width (or width min-width)
     :max-width (or width max-width "none")
     :width     (or width "auto")}
    word-break (assoc :word-break word-break)))

(defc table-header-col
  [{:keys [title sortable render-header] :as column}]
  (let [{:keys [state update-state]}              (hooks/use-context table-context)
        column-key                                (:key column)

        ;; TODO: Multiple sort cols
        [current-sort-key current-sort-direction] (first (:sort @state))
        sorted                                    (= current-sort-key column-key)

        el                                        (if sortable :button :div)
        title                                     (loc (or title (:key column)))]
    [el
     {:class    ["stable-header-cell"
                 (when sortable "sortable")
                 (when sorted "sorted")]
      :role     "columnheader"
      :data-cy  "table-header-cell"
      :on-click (when sortable
                  (fn [_e]
                    (update-state assoc :sort [[column-key (if sorted
                                                             ({:desc :asc
                                                               :asc  :desc} current-sort-direction)
                                                             (or (:default-direction column)
                                                                 :asc))]])))
      :style    (create-cell-style column)}
     [:span.label
      (if render-header
        [render-header title]
        title)]
     (when sorted
       [:div.stable-sort-icon
        {:class (when (= current-sort-direction :desc) "desc")}
        [icons/arrow-up {:size 16}]])]))

(defc table-settings-button [{:keys [size]}]
  (let [{:keys [update-state]} (hooks/use-context table-context)]
    [button
     {:intent     :text
      :size       (or size :md)
      :on-click   (fn [_e]
                    (update-state assoc :config-modal-open true))
      :aria-label (loc :table.adjustments)
      :data-cy    "table-settings-button"}
     [icons/settings-adjust {:size 16}]]))

(defc ^:private table-row-wrapper
  [{:keys [; expanded?
           ; on-expand
           ; focus?
           ; target-props
           ; selecting?
           ; selected?
           ]}
   & children]
  (let [ref         (hooks/use-ref nil)

        ;; TODO
        expandable? false
        expanded?   false
        focus?      false
        selecting?  false
        selected?   false]
    (into [:div
           (r/merge-props {:class   (into ["stable-row"]
                                          (if selecting?
                                            [(if selected?
                                               "stable-row--selected"
                                               "stable-row--selectable")]
                                            [(when expandable?
                                               "stable-row--clickable")
                                             (when expanded?
                                               "stable-row--expanded")
                                             (when focus?
                                               "stable-row--focused")]))
                           :role    "row"
                           :data-cy "table-row"
                           :ref     ref})]
          children)))

(defc row-column [{:keys [row column]}]
  (let [{:keys [render]} column
        render-fn        (or render identity)
        ;; TODO: This get part will be handled before render,
        ;; as this will need to run first for sorting (if using UI sort)
        get-fn           (:get column)
        value            (get-fn row)
        content          (render-fn value row)]
    [:<>
     [:div.stable-cell
      {:role    "cell"
       :style   (create-cell-style column)
       :data-cy "table-column"}
      content]
     (when content
       [:div.stable-responsive-cell
        {:role "cell"}
        [:div.header
         {:aria-hidden true}
         (loc (or (:title column) (:key column)))]
        [:div.content
         {:data-cy "table-column"}
         content]])]))

(defc table-row [row]
  (let [{:keys [get-row-id visible-columns]} (hooks/use-context table-context)
        row-key                              (get-row-id row)

        expanded?                            false
        selected?                            false]
    ^{:key row-key}
    [:<>
     [table-row-wrapper {}
      [:div.stable-row-first-col
       (cond
         ;; TODO:
         false ;; draggable-props
         [:div.stable-row-icon-col
          {:data-cy "table-row-drag-handle"}
          [icons/draggable {:size 24}]]

         false ;; selecting?
         [:div.stable-row-icon-col
          [:input
           {:type       "checkbox"
            :aria-label (str "Select row " row-key)
            :checked    (boolean selected?)
            :on-change  (fn [_e]
                          #_(on-select (.. e -target -checked) key))}]]

         false ;; row-expanded?
         [:div.stable-row-icon-col
          (if expanded?
            [icons/chevron-up {:size 24}]
            [icons/chevron-down {:size 24}])])]

      [:div.stable-row-cols
       (for [column @visible-columns]
         ^{:key (:key column)}
         [row-column
          {:row    row
           :column column}])]]

     (when expanded?
       ^{:key "expansion"}
       [:div.stable-expansion-wrapper
        [:div.stable-expansion-inner
         [:div.stable-expanded-content
          {:data-cy "table-row-expanded-content"}
          "TODO: Render row expanded content"]]])]))

(defc pagination-page-size []
  (let [{:keys [state update-state]} (hooks/use-context table-context)
        {:keys [limit]}              @state
        current-limit                limit]
    [:<>
     [:span.mr-2.text-h6.font-bold
      (loc :table.rows-per-page)]
     [toggle-group
      {:value     current-limit
       :on-change (fn [option _e]
                    (update-state assoc :limit (:value option) :start 0))
       :options   (mapv (fn [i]
                          {:key   i
                           :title (str i)
                           :value i})
                        [20 50 100])}]]))

(defc pagination-current-page []
  (let [{:keys [state update-state total-rows]} (hooks/use-context table-context)
        {:keys [start limit]}                   @state
        max-page                                (when total-rows
                                                  (js/Math.ceil (/ total-rows limit)))
        current-page                            (js/Math.floor (/ start limit))]
    [toggle-group
     {:value     current-page
      :on-change (fn [option _e]
                   (update-state assoc :start (* (:value option) limit)))
      :options   (mapv (fn [i]
                         {:key   i
                          :title (str (inc i))
                          :value i})
                       (range max-page))}]))

(defc pagination-num-results []
  (let [{:keys [state total-rows num-rows]} (hooks/use-context table-context)
        {:keys [start]}                     @state]
    [:span (loc :table.showing-rows
                ;; NOTE: A bit funny, as start value is local state,
                ;; vs num-rows which updates only when the server
                ;; results are received.
                (if (pos? @num-rows)
                  (str (inc start) "-" (+ start @num-rows))
                  "0")
                (or total-rows 0))]))

(defc pagination []
  (let [{:keys [server-side]} (hooks/use-context table-context)]
    ;; TODO: Local pagination
    (when server-side
      [:div.flex.flex-row.items-center.flex-wrap.gap-2
       [pagination-num-results]
       [pagination-current-page]
       [pagination-page-size]])))

(defc toolbar []
  (let [{:keys [slots]} (hooks/use-context table-context)]
    [:div.stable-toolbar
     (if-let [f (:toolbar slots)]
       [f]
       [:<>
        [pagination]
        [:div.flex-1]
        [table-settings-button]])]))

(defn- get-column-visibility [state {:keys [key hidden-by-default?] :as _column}]
  (get-in state [:columns key] (not hidden-by-default?)))

(defc ^:private column-selector-row [{:keys [column uncheck-allowed? index]}]
  (let [{:keys [state update-state]} (hooks/use-context table-context)

        col-key                      (:key column)
        title                        (or (:title column) col-key)
        checked?                     (get-column-visibility @state column)

        {:keys [ref handleRef]}
        (->clj (useSortable #js {:id    (name col-key)
                                 :index index}))]
    [:div.stable-config-row
     {:ref ref}
     [:div.stable-config-row-handle
      {:ref handleRef}
      [icons/drag-vertical {:size 16}]]
     [:div.flex-1
      [:label.flex.items-center.gap-2.cursor-pointer
       [:input
        {:type      "checkbox"
         :id        (str col-key)
         :on-change (fn [e]
                      (update-state assoc-in [:columns col-key] (.. e -target -checked)))
         :checked   checked?
         :disabled  (and checked? (not uncheck-allowed?))}]
       (loc title)]]]))

(defn- move-item [v from to]
  (let [item    (nth v from)
        without (into (subvec v 0 from) (subvec v (inc from)))]
    (into (conj (subvec without 0 to) item) (subvec without to))))

(defc ^:private column-selector []
  (let [{:keys [state update-state ordered-columns]} (hooks/use-context table-context)
        uncheck-allowed?                             (->> @ordered-columns
                                                          (filter #(get-column-visibility @state %))
                                                          rest
                                                          seq)
        col-keys                                     (mapv :key @ordered-columns)]
    [:div
     [:> DragDropProvider
      {:on-drag-end (fn [^js e]
                      (let [source (.-source (.-operation e))
                            from   (.-initialIndex source)
                            to     (.-index source)]
                        (when (not= from to)
                          (update-state assoc :order (move-item col-keys from to)))))}
      (map-indexed
        (fn [i column]
          ^{:key (:key column)}
          [column-selector-row {:column           column
                                :uncheck-allowed? uncheck-allowed?
                                :index            i}])
        @ordered-columns)]]))

(defc ^:private expand-default-toggle []
  (let [{:keys [state update-state]} (hooks/use-context table-context)
        {:keys [expand-by-default]}  @state]
    [:div.stable-config-toggle
     [:label
      [:input
       {:type      "checkbox"
        :checked   expand-by-default
        :on-change (fn [e]
                     (update-state assoc :expand-by-default (.. e -target -checked)))}]
      (loc :table.toggle-expand-default)]]))

(defc ^:private column-config-modal []
  (let [{:keys [state update-state]} (hooks/use-context table-context)
        {:keys [config-modal-open]}  @state]
    [dialog/root
     {:open           config-modal-open
      :on-open-change (fn [open?]
                        (update-state assoc :config-modal-open open?))}
     [dialog/portal
      {:class ["nobase twp lp-theme"]}
      [dialog/backdrop]
      [dialog/popup {:class "max-w-md"}
       [:div.stable-config-header
        [dialog/title (loc :table.adjustments)]
        [:div.flex-1]
        [dialog/close
         [icons/close]]]
       [dialog/viewport {}
        [:div.p-4
         [:div.stable-config-content
          [column-selector]
          (when false ;; expandable?
            [expand-default-toggle])
          [:div.stable-config-footer
           [:div.flex-1]
           [button
            {:size     :sm
             :intent   :secondary
             :on-click (fn [_e]
                         (update-state assoc :columns nil :order nil))}
            (loc :table.restore-default-settings)]]]]]]]]))

(def ColumnDef
  [:map ;; {:closed false}
   [:key ColumnKey]
   [:title {:optional true} ColumnKey]
   [:get :any]
   [:render {:optional true} :any]
   [:render-header {:optional true} :any]
   [:sortable {:optional true} :boolean]
   [:default-direction {:optional true} [:enum :asc :desc]]
   [:cell-style {:optional true} :any]])

(def TableOptions
  [:map {:closed false}
   [:id {:optional true} :string]
   [:columns [:vector ColumnDef]]
   ;; nil allowed during initialization/loading?
   [:rows [:maybe [:vector :any]]]
   [:get-row-id :any]
   [:get-rows {:optional true} :any]
   [:total-rows {:optional true} [:maybe :int]]

   [:initial-state {:optional true} :any]

   [:classes {:optional true} [:map-of :keyword :any]]
   [:slots {:optional true} [:map-of :keyword :any]]])

(def ^:private validate-table-options (m/validator TableOptions))
(def ^:private explain-table-options (m/explainer TableOptions))

(defn use-reactive-value
  "Given a value, return a stable ratom value that will follow the same value.
  Useful for turning a regular component property into a ratom that can be
  used as input to reactions and passed into the context."
  [value]
  (let [ratom* (hooks/use-ref nil)]
    ;; Create the ratom once
    (when (nil? (.-current ratom*))
      (set! (.-current ratom*) (r/atom nil)))
    ;; Place the latest value into ratom
    (reset! (.-current ratom*) value)
    (.-current ratom*)))

(defn use-reaction
  "Create a reaction that is stored on a ref and runs the given function."
  [f]
  ;; FIXME: Should this check for f changes?
  (let [r-ref (hooks/use-ref nil)]
    (when (nil? (.-current r-ref))
      (set! (.-current r-ref) (ratom/make-reaction f)))
    ;; Reactions aren't marked auto-run, so they only run when someone
    ;; is dereferencing them, but to be safe, it is OK to also
    ;; dispose them.
    (hooks/use-effect (fn []
                        (fn []
                          (r/dispose! (.-current r-ref))))
                      [])
    (.-current r-ref)))

(defc table
  "## Table options:
    `:columns` - (required) collection of column definitions
    `:rows` - (required) collection of items to render as rows
    `:get-row-id` - (required) item -> row key

  Server side pagination and sort:

    `:get-rows` - Enables server side pagination and sort
    `:total-rows` - Total number of rows for server side pagination.

  ## Table `:style`Style options:

    `:classes` - slot name => class
    `:slots` - slot => custom component (available slots, `:toolbar`, `:loading`)

  ## Column definitions:

    `:key` - (required) Column key
    `:get` - (required) Value getter
    `:title`
    `:render` - Renderer fn
    `:render-header`
    `:sortable` - Is column sortable
    `:cell-style` - Set width etc. for header and row cells.

  ## Table `:classes`
  Available :classes slots, if these have defaults, setting the option will replace it.
  Useful for replacing the media queries for switching between responsive card and table views.

    `:container` - `stable-card-view lg:stable-table-view`
    `:body`
    `:table`"
  [{:keys [get-row-id
           get-rows
           classes
           slots
           state-updated
           loading]
    :as   opts}]
  (when ^boolean js/goog.DEBUG
    (when-not (validate-table-options opts)
      (js/console.warn "sortable-table: invalid options" (pr-str (explain-table-options opts)))))
  (let [;; Store internal state in local atom
        ;; NOTE: State value is a bit more complex currently, so it doesn't use use-reactive-value hook.
        internal-state*            (hooks/use-ref nil)
        _                          (when (nil? (.-current internal-state*))
                                     (set! (.-current internal-state*) (r/atom (merge initial-state
                                                                                      (:initial-state opts)))))
        state                      (.-current internal-state*)

        ;; Copy provided loading value into internal state
        _                          (when (contains? opts :loading)
                                     (swap! state assoc :loading loading))

        ;; Copy rows into ratom so it can be used as input to reactions,
        ;; and passed into the context as a stable ratom instance.
        rows                       (use-reactive-value (:rows opts))
        columns                    (use-reactive-value (:columns opts))

        ;; Always store changes to the internal-state
        update-state               (hooks/use-memo (fn []
                                                     (fn [f & args]
                                                       (swap! (.-current internal-state*) (fn [x]
                                                                                            (apply f x args)))))
                                                   [internal-state*])

        ;; Be careful of using non-reactive values inside the reaction bodies!
        ordered-columns            (use-reaction
                                     (fn []
                                       (let [column-order (:order @state)
                                             col->idx     (into {} (map-indexed (fn [idx column-key]
                                                                                  [column-key idx])
                                                                                column-order))]
                                         (if column-order
                                           (->> @columns
                                                (sort-by (fn [column]
                                                           (get col->idx (:key column) js/Number.MAX_VALUE)))
                                                vec)
                                           @columns))))

        visible-columns            (use-reaction
                                     (fn []
                                       (->> @ordered-columns
                                            (filterv (fn [column]
                                                       (get-column-visibility @state column))))))

        num-rows                   (use-reaction (fn [] (count @rows)))

        ;; TODO: ^ use the reaction pattern to implement the local sort, pagination etc.

        context                    (hooks/use-memo (fn []
                                                     ;; TODO: Does opts change trigger this again every time?
                                                     ;; Also need to check if the memo return value is clj = to the previous?
                                                     (merge (select-keys opts [:get-row-id
                                                                               :classes
                                                                               :slots
                                                                               :total-rows])
                                                            {:state           state
                                                             :update-state    update-state
                                                             :server-side     (boolean get-rows)
                                                             :ordered-columns ordered-columns
                                                             :visible-columns visible-columns
                                                             ;; :rows rows
                                                             :num-rows        num-rows}))
                                                   [opts state update-state])

        {:keys [sort start limit]} @state]
    (hooks/use-effect (fn []
                        (when state-updated
                          (let [r (ratom/run! (state-updated @state))]
                            (fn []
                              (r/dispose! r)))))
                      [state-updated])
    (hooks/use-effect (fn []
                        (when get-rows
                          (get-rows {:sort  sort
                                     :start start
                                     :limit limit})))
                      [get-rows sort start limit])
    ;; FIXME: use-reaction solution is triggering extra renders still,
    ;; due to the table first being rendered when props change (e.g. rows),
    ;; and again on the reaction change.
    ;; Consider something to solve this? How do JS libs handle "similar" reactive values?
    ;; useMemo alone isn't enough, as we also need to pass the "calculation result" into the
    ;; context, without the context identity changing all the time.
    ;; (js/console.log "table rendered")
    [:r> TableContextProvider
     #js {:value context}
     [:div.stable-container
      {:class [(:container classes "stable-card-view lg:stable-table-view")]}
      [:div
       {:data-cy "table"
        :role    "table"
        :class   ["stable" (:table classes "")]}
       [:div.stable-thead-group
        {:role "rowgroup"}
        [toolbar]
        [:div.stable-thead-row
         {:role "row"}
         (for [column @visible-columns]
           ^{:key (:key column)}
           [table-header-col column])]]
       [:div.stable-body
        {:class (:body classes)}
        (when (:loading @state)
          (if-let [f (:loading slots)]
            [f]
            [:div.stable-loading
             [spinner]]))
        (doall
          (for [row @rows]
            ^{:key (get-row-id row)}
            [table-row row]))]]
      [column-config-modal]]]))

;; - Do we need sort-by multiple columns? Currently can only sort on one col. No secondary sort, if first col has same value.
;; TODO:
;; - sortable headers for responsive column titles
;; - local sort
;; - local pagination
;; - expandable rows
;; - selectable rows
;; - row order/drag and drop

;; Ideas:
;; - Provide "context" using React Context, so the children components can access
;;   update-state, header declarations etc. anywhere without it being passed through all layers.
;;   - Rows and other large and potentially often updated values must not be part of context directly, but the can be wrapped into
;;     ratoms
